import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { completeOnboarding } from './types';

import { onboardingCompleteSuccess, onboardingCompleteFailure } from './actions';

const logger = new Logger('Saga:Onboarding');

export function* requestCompleteOnboarding({ preference }) {
  const routerService = yield getContext('routerService');
  const authApiService = yield getContext('authApiService');

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.update_onboarding_preferences', { preference }),
    );

    yield response && put(onboardingCompleteSuccess(preference));
  } catch (error) {
    logger.error('Failed to complete onboarding: ', error);
    yield put(onboardingCompleteFailure(error));
  }
}

export default function* onboardingSaga() {
  return yield all([takeLatest(completeOnboarding.request, requestCompleteOnboarding)]);
}
